import api from '../callApi';

// Either state or zipCode is required
const apiInitiateVoteRegistration = (apiRequestData, id, state, dateOfBirth, zipCode) => {
    const request = {
        ...apiRequestData,
        id,
        state,
        dateOfBirth,
        zipCode
    };

    return api.post('Widget/InitiateVoteRegistrationAsync', request).then(response => {
        return response;
    });
};

export default apiInitiateVoteRegistration;
